module.exports = __webpack_public_path__ + "img/search-bar.78c8a3f1.png";